import { Navigate, useRoutes } from 'react-router-dom';
import MainLayout from '../layouts/main';
// config
//
import { HomePage, Page404, Big5Page, SalesProcessPage, AfterSalesHealthCheckPage, DashboardPage, SuccessDashboardPage } from './elements';

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    {
      element: <MainLayout />,
      children: [{ path: '404', element: <Page404 /> }],
    },
    {
      element: <MainLayout />,
      children: [{ path: '/', element: <HomePage /> }],
    },
    {
      element: <MainLayout />,
      children: [{ path: 'test/big5/:variantId', element: <Big5Page /> }],
    },
    {
      element: <MainLayout />,
      children: [{ path: 'test/sales-process/:variantId', element: <SalesProcessPage /> }],
    },
    {
      element: <MainLayout />,
      children: [{ path: 'test/after-sales-health-check/:variantId', element: <AfterSalesHealthCheckPage /> }],
    },
    {
      element: <MainLayout />,
      children: [{ path: 'dashboard', element: <DashboardPage /> }],
    },
    {
      element: <MainLayout />,
      children: [{ path: 'success-dashboard', element: <SuccessDashboardPage /> }],
    },
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
